import { InMemoryPhoto, FinalizedPhoto, UploadedPhoto, UploadPendingPhoto } from '@models/*';

export type PhotoTypeInProtocolComponent = InMemoryPhoto | UploadedPhoto | FinalizedPhoto | UploadPendingPhoto;

export type NotYetFinalizedPhotoType = InMemoryPhoto | UploadedPhoto | UploadPendingPhoto;

export const isUploadPendingPhoto = (photo: PhotoTypeInProtocolComponent): photo is UploadPendingPhoto => {
    return !photo.hasOwnProperty('signedURL') && !photo.hasOwnProperty('data') && !photo.hasOwnProperty('url');
};

export const isUploadedPhoto = (photo: PhotoTypeInProtocolComponent): photo is UploadedPhoto => {
    return photo.hasOwnProperty('signedURL');
};

// todo: make sure this has no conflicts with the other photo type "InUploadQueue" which also has "data" property
export const isInMemoryPhoto = (photo: PhotoTypeInProtocolComponent): photo is InMemoryPhoto => {
    return photo.hasOwnProperty('data');
};

export const isFinalizedPhoto = (photo: PhotoTypeInProtocolComponent): photo is FinalizedPhoto => {
    return photo.hasOwnProperty('url') && photo.hasOwnProperty('position');
};

export const isNotYetFinalizedPhoto = (photo: PhotoTypeInProtocolComponent): photo is NotYetFinalizedPhotoType => {
    return !isFinalizedPhoto(photo);
};
